import { Room, RoomEvent } from 'livekit-client';
import { useEffect, useRef } from 'react';

export const useRoomReconnection = (room: Room | null) => {
  const reconnectAttempts = useRef<number>(0);

  const onReconnecting = () => {
    reconnectAttempts.current++;

    console.warn(`Connection lost. Attempt ${reconnectAttempts.current} to reconnect...`);
  };

  const onReconnected = () => {
    reconnectAttempts.current = 0;
  };

  useEffect(() => {
    if (!room) return;

    room.on(RoomEvent.Reconnecting, onReconnecting);
    room.on(RoomEvent.Reconnected, onReconnected);

    return () => {
      room.off(RoomEvent.Reconnecting, onReconnecting);
      room.off(RoomEvent.Reconnected, onReconnected);
    };
  }, [room, onReconnecting, onReconnected]);
};
